import { apiClient, apiEndpoint } from '../api.services';
import { API } from '../../constants/api.constants';
import type { QueryParams, FuncResponse, ApiResponse } from './system-canvas.types';

export const getAllBrands = async (params: QueryParams): Promise<FuncResponse> => {
  try {
    const brands: ApiResponse = await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_BRANDS}`, {
      params,
    });
    if (brands.code === 200) {
      return {
        data: brands.data,
        status: true,
      };
    }
    throw new Error('Failed to fetch brands');
  } catch (error) {
    return {
      data: [],
      status: false,
    };
  }
};

export const getSubBrandsByBrandId = async (params: QueryParams): Promise<FuncResponse> => {
  try {
    const subBrands: ApiResponse = await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_SUB_BRAND}`, {
      params,
    });
    if (subBrands.code === 200) {
      return {
        data: subBrands.data,
        status: true,
      };
    }
    throw new Error('Failed to fetch brands');
  } catch (error) {
    return {
      data: [],
      status: false,
    };
  }
};

export const getMultiSubBrandsByBrandIds = async (params: { brandIds: string[]; isActive?: boolean }): Promise<FuncResponse> => {
  try {
    const subBrands: ApiResponse = await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MULTI_SUB_BRAND}`, {
      params: {
        brandIds: params.brandIds.join(','),
        ...(params.isActive !== undefined && { isActive: params.isActive }),
      },
    });
    if (subBrands.code === 200) {
      return {
        data: subBrands.data,
        status: true,
      };
    }
    throw new Error('Failed to fetch sub brands');
  } catch (error) {
    return {
      data: [],
      status: false,
    };
  }
};

export const getProductTypes = async (params: QueryParams): Promise<FuncResponse> => {
  try {
    const productTypes: ApiResponse = await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_PC_TYPE}`, {
      params,
    });
    if (productTypes.code === 200) {
      return {
        data: productTypes.data,
        status: true,
      };
    }
    throw new Error('Failed to fetch product types');
  } catch (error) {
    return {
      data: [],
      status: false,
    };
  }
};

export const getCategories = async (data: QueryParams): Promise<FuncResponse> => {
  try {
    const categories: ApiResponse = await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.FETCH_TYPE_BASED_CATEGORY}`, data);
    if (categories.code === 200) {
      return {
        data: categories.data,
        status: true,
      };
    }
    throw new Error('Failed to fetch categories');
  } catch (error) {
    return {
      data: [],
      status: false,
    };
  }
};

export const getCatBasedOnPT = async () => {
  try {
    const isCatBasedOnPT: ApiResponse = await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CAT_BASED_ON_PT}`);
    if (isCatBasedOnPT.code === 200) {
      return {
        data: isCatBasedOnPT.data,
        status: true,
      };
    }
    throw new Error('Failed to fetch cat based on PT');
  } catch (error) {
    return {
      data: false,
      status: false,
    };
  }
};
